module.exports = __webpack_public_path__ + "img/IMG_1444_L_WoodMatted.91c9f9f8.jpg";